import React, { useState } from "react";
import { IconButton, Menu } from "@material-ui/core";
import { MoreVert } from "@material-ui/icons";
import MenuItem from "@material-ui/core/MenuItem";
import locale from "@bonliva-crm/locale";
import { BOOKING_SLIDER, BookingEditLocation } from "@navigation";
import { store } from "@store";
import { BookingDuplicateLocation } from "@navigation/locations/BookingDuplicateLocation";

export default function RowActions(props: {
  id: string;
  onCloneBooking: (bookingId: string) => void;
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { navigation } = store();

  const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleButtonClick}
      >
        <MoreVert />
      </IconButton>

      <Menu open={open} id="basic-menu" anchorEl={anchorEl} onClose={handleMenuClose}>
        <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            navigation.open(BOOKING_SLIDER, new BookingEditLocation(props.id));
            setAnchorEl(null);
          }}
        >
          {locale.Edit}
        </MenuItem>

        <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            navigation.open(BOOKING_SLIDER, new BookingDuplicateLocation(props.id));
            setAnchorEl(null);
          }}
        >
          {locale.Duplicate}
        </MenuItem>

        {store().user.can("booking:clone:all") && (
          <MenuItem
            onClick={(e) => {
              e.stopPropagation();
              props.onCloneBooking(props.id);
              setAnchorEl(null);
            }}
          >
            {locale.MonthlyBrake}
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
